import { makeStyles } from "@material-ui/core/styles";

export function useReschedulingListStyles() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    header: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "1.3rem",
    },
    title: {
      fontWeight: 400,
      fontSize: "1.5rem",
    },
    textField: {
      margin: 16,
      width: "40%",
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
